import {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import Logger from '@nl/logger';
import {loadScript, loadScripts} from '../utils/utils';

const useAdInitialization = () => {
	const {
		config: {
			data: {
				AD_FUEL: {
					enabled,
					WMUserConsentConfig,
					WMUserConsentLibrary,
					target,
					libraries,
				},
			},
			isRequested,
		},
		client: {
			data: {
				country,
			},
		},
	} = useSelector((state) => state, shallowEqual);
	const [isAdFuelReady, setAdFuelReady] = useState(false);
	const {pathname} = useLocation();

	useEffect(() => {
		if (isAdFuelReady && window.AdFuel) {
			// TODO: Need update when category info ready
			// window.AdFuel.addPageLevelTarget('category', pathname);
		}
	}, [pathname, isAdFuelReady]);

	useEffect(() => {
		const initUserConsent = () => {
			if (window.WM && window.WM.UserConsent) {
				window.WM.UserConsent.init({...WMUserConsentConfig, countryCode: country || 'US'});
			}
			return Promise.resolve();
		};
		const initAdFuel = () => {
			if (window.AdFuel && target) {
				// window.AdFuel.addPageLevelTarget('status', target);
				setAdFuelReady(true);
			}
		};

		if (isRequested && enabled) {
			try {
				loadScript(WMUserConsentLibrary)
						.then(initUserConsent)
						.then(() => loadScripts(libraries))
						.then(initAdFuel);
			} catch (err) {
				Logger.warn('ad fuel init error:', err);
			}
		}
	}, [isRequested, enabled, target, libraries, country, WMUserConsentLibrary, WMUserConsentConfig]);
};

export default useAdInitialization;
